// FileViewerModal.js
import React, { useEffect, useState, useRef } from "react";
import { Modal, Box, Backdrop, CircularProgress } from "@mui/material";
import { isEmptyDash, urlConstants } from "../../constant";
import AlertComponent from "../alert/alert";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import Switch from "@mui/material/Switch";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { UserObj } from "../../services/localStarage";
import _ from "lodash";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { htmlDocs } from "./draftToHtml";

const requestesignstyle = {
  position: "absolute",
  top: "50%",
  left: "47%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


const RequestSignModal = (props) => {
  const userRole = UserObj ? UserObj?.role?.name : "";
  const [fileSrc, setfileSrc] = useState(null);
  const [poDetails, setPoDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const [content, setContent] = React.useState({
    editorStateOne: EditorState.createWithContent(htmlDocs("<p></p>"))
  });

  // const [editorValue, setEditorValue] = React.useState({
  //   editorOneValue: "",
  // });

  const onEditorStateChangeOne = (editorState) => {
    setContent({ editorStateOne: editorState });
  };

  useEffect(() => {
    // setEditorValue({ editorOneValue: draftToHtml(convertToRaw(content?.editorStateOne?.getCurrentContent())) });
    setPoDetails((prevData) => ({ ...prevData, customTnc: draftToHtml(convertToRaw(content?.editorStateOne?.getCurrentContent())), }));
  }, [content]);

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    setPoDetails(props?.poDetails);

    let data1 = !isEmptyDash(props?.poDetails?.customTnc) ? htmlDocs(props?.poDetails?.customTnc, "editorStateOne") : htmlDocs("<p></p>");
    setContent({ editorStateOne: EditorState?.createWithContent(data1) });
  }, [props?.poDetails]);

  useEffect(() => {
  }, [poDetails]);

  const handleChangeswich = (event) => {
    // setChecked(event.target.checked);
    setPoDetails((prevData) => ({ ...prevData, milestonesRequired: event.target.checked }));
  };

  const submit = (param) => {

    // if (poDetails?.customTnc == "<p></p>\n" && poDetails?.milestonesRequired == true) {
    //   setAlertComponent({ open: true, type: "error", message: `Please enter T&C. ` });
    //   return;
    // }
    // if (poDetails?.milestonesRequired == true && poDetails?.milestones.length < 1) {
    //   setAlertComponent({ open: true, type: "error", message: `Please add milestone. ` });
    //   return;
    // }
    if (poDetails?.milestonesRequired == true && poDetails?.milestones.length > 0 && calcSum()?.totalPercent != 100) {
      setAlertComponent({ open: true, type: "error", message: `Total sum of milestones's percentage should be 100. ` });
      return;
    }
    let bodyData = {
      "poId": props?.purchaseOrderIds,
      "milestonesRequired": poDetails?.milestonesRequired,
      "milestones": poDetails?.milestones,
      "customTnc": poDetails?.customTnc
    }

    props.submitSign(bodyData);
  }

  const addRow = (e) => {
    let obj = {
      "name": "",
      "percentage": "",
      "payment": ""
    };
    setPoDetails((prevData) => ({ ...prevData, milestones: [...prevData?.milestones, obj] }));
  };

  const deleteRow = (i) => {
    let mileStoneArrInit = _.cloneDeep(poDetails?.milestones);
    let filterArr = mileStoneArrInit.filter((ele, eleIdx) => eleIdx != i);
    setPoDetails((prevData) => ({ ...prevData, milestones: filterArr }));
  };

  const calcSum = () => {
    let total = 0;
    let totalPercent = 0;
    let mileStoneArrInit = _.cloneDeep(poDetails?.milestones);
    for (let i = 0; i < mileStoneArrInit.length; i++) {
      total += Number(mileStoneArrInit[i].payment);
      totalPercent += Number(mileStoneArrInit[i].percentage);
    }
    return { "total": total.toFixed(2), totalPercent };
  };

  const onTextChange = (e, row, rowIndex) => {
    let { name, value } = e.target;
    let mileStoneArrInit = _.cloneDeep(poDetails?.milestones);
    mileStoneArrInit[rowIndex][name] = value;
    if (name == "percentage") {
      let amount = Number(props?.poDetails?.netValue);
      let percentVal = amount * value / 100;
      mileStoneArrInit[rowIndex]["payment"] = percentVal.toFixed(2);
    }
    // setMileStoneArr(mileStoneArrInit);
    setPoDetails((prevData) => ({ ...prevData, milestones: mileStoneArrInit }));
  };


  // const onTextAreaChange = (e) => {
  //   let {name, value} = e.target;    
  //   setTextAreaText(value);
  // };

  // const openAlert = (open, type, message) => {
  //   // setAlertComponent({ open, type, message });
  // };

  const isModify = () => {
    let str = false;
    // if (props?.poDetails?.status == "Sign Requested") {
    //   str = true;
    // }
    return str;
  };

  const isAddRow = () => {
    let str = false;
    if (poDetails?.milestonesRequired == true) {
      str = true;
    }
    return str;
  };

  useEffect(() => {
    if (!isEmptyDash(props?.purchaseOrderIds) && props.isOpen == true) {
      downloadPO();
    }
  }, [props?.purchaseOrderIds, props.isOpen]);

  // useEffect(() => {  
  // }, [uploadObj?.response]);

  const downloadPO = () => {
    setIsLoading(true);
    let bodyData = {
      "poNumber": props?.poDetails?.poNumber,
      "type": "po-pdf", // "line-item", header, po-pdf
    };

    let url = `${urlConstants.BASE_URI_DEV}/v1/common/purchase-orders/download`;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify(bodyData);

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(url, requestOptions)
      .then(response => {
        if (response.status === 400) {
          throw new Error(`Bad Request: ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        const urlInit = URL.createObjectURL(blob);
        setfileSrc(urlInit);
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
  const closeModal = (e) => {
    props.closeRequestSign();
    setfileSrc(null);
  };
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div>
      <Modal
        open={props.isOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={requestesignstyle}
          className="modal_requestesign_section_row_editer"
        >
          <div className="modal_header_requeste_sign">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Request Sign  <label className="lets_ponumber_modal"> PO Number: </label><label class="lets_pakage_code_creation">{props?.poDetails?.poNumber}</label>
            </h1>
        <div className="milestone_requestsigncancel_submitbtns">
        <div className="card_tabs_milstone">
                {/* {userRole === "MANAGER" ? (
                      <button class="btn btn-outline-secondary">
                        Place E-Sign
                      </button>
                    ) : null} */}
                <button
                  class="btn btn-outline-secondary"
                  onClick={closeModal}
                >
                  Discard
                </button>
                {userRole === "BUYER" ? (
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={submit}
                  >
                    Submit
                  </button>
                ) : null}
                {userRole === "MANAGER" ? (
                  <button
                    class="btn btn-outline-secondary"
                  // onClick={props.closeRequestSign}
                  >
                    Approve
                  </button>
                ) : null}
              </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={closeModal}
            ></button>
        </div>            
          </div>          
          <div className="first_main_rowmodal_request_esignmodal">
            <div class="modal-body">
              <div className="rowmiles_order_reader">
            <div className="first_one_milstone_row">
            <div className="miles_order_reader" style={{width:"100%"}}>
                  {/* <img src={esignpdfImages} alt="" /> */}
                  {(fileSrc != null) && <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                    <div style={{ height: "90vh" }}>
                      <Viewer fileUrl={fileSrc} plugins={[defaultLayoutPluginInstance]} />
                    </div>
                  </Worker>}
                </div>
            </div>
                <div className="second_one_milestone_row">
                  <div className="rowmiles_technical_readers">
                    <p className="order_reader_milestsign">
                      Do you want to add Milestone and T&C
                    </p>
                    <div>
                      <Switch
                        checked={poDetails?.milestonesRequired}
                        onChange={handleChangeswich}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      {(isModify()) && <button className="btn btn-outline-secondary">
                        <EditTwoToneIcon />
                        Modify
                      </button>}
                      {(isAddRow()) && <button className="btn btn-outline-secondary addrow_btnse" onClick={addRow}>
                        {/* <EditTwoToneIcon /> */}
                        Add row
                      </button>}
                    </div>
                  </div>
                  {(poDetails?.milestonesRequired == true) && <><div style={{width:"100%", overflowY:"scroll", height:"30vh"}} className="listing_main miles_order_reader">
                    <table>
                      <thead>
                        <tr>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Milestone
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Milestone (%)
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                              Payment
                            </p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {poDetails?.milestones?.length < 1 && <>
                          <tr>
                            <td colSpan={3} className="text-center list-no-data">No Data Found</td>
                          </tr>
                        </>}
                        {poDetails?.milestones?.map((row, rowIndex) => (
                          <tr className="maine_tr_vendor">
                            <td className="lets_table_blocklist_react_order">
                              <input
                                class="form-control form-haswe-milestone"
                                type="text"
                                placeholder="Milestone One"
                                name="name"
                                onChange={(e) => onTextChange(e, row, rowIndex)}
                                value={row?.name}
                              />
                            </td>
                            <td className="lets_table_blocklist_react_order">
                              <div className="input_div_react_percentage">
                                <input
                                  class="form-control form-haswe-milestone"
                                  type="number"
                                  fdprocessedid="93wdif"
                                  name="percentage"
                                  onChange={(e) => onTextChange(e, row, rowIndex)}
                                  value={row?.percentage}
                                />
                                <PercentOutlinedIcon />
                              </div>
                            </td>
                            <td className="lets_table_blocklist_react_order">
                              ₹{row?.payment}
                            </td>
                            {(rowIndex != 0) && <td>
                              <HighlightOffIcon className="highlight_close_btn" onClick={() => deleteRow(rowIndex)} />
                            </td>}
                          </tr>
                        ))}
                        {poDetails?.milestones?.length > 0 && <>
                          <tr className="maine_tr_vendor">
                            <td className="lets_table_blocklist_react_order"></td>
                            <td className="lets_table_blocklist_react_orders_milestone">
                              Total : ₹{Number(props?.poDetails?.netValue).toFixed(2)}
                            </td>
                            <td className="lets_table_blocklist_react_order">
                              ₹{calcSum()?.total}
                            </td>
                            <td className="lets_table_blocklist_react_order"></td>
                          </tr>
                        </>}
                      </tbody>
                    </table>
                  </div>
                    <div className="custome_tabspanel" style={{ maxHeight: "200px" }}>
                      <p className="order_reader_milestsign">
                        Custom T&C
                      </p>
                      {/* <textarea
                          style={{ height: "10vh" }}
                          name="Message"
                          id="address"
                          class="form-control message-body_bbdt"
                          spellcheck="false"
                          placeholder="Please enter"
                          value={textAreaText}
                          onChange={onTextAreaChange}
                        ></textarea> */}
                      <Editor
                        editorState={content.editorStateOne}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={onEditorStateChangeOne}
                      />
                    </div></>}
                </div>
              </div>
            </div>
          </div>
          <div className="card_tabs_milstone">
                {/* {userRole === "MANAGER" ? (
                      <button class="btn btn-outline-secondary">
                        Place E-Sign
                      </button>
                    ) : null} */}
                <button
                  class="btn btn-outline-secondary"
                  onClick={closeModal}
                >
                  Discard
                </button>
                {userRole === "BUYER" ? (
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={submit}
                  >
                    Submit
                  </button>
                ) : null}
                {userRole === "MANAGER" ? (
                  <button
                    class="btn btn-outline-secondary"
                  // onClick={props.closeRequestSign}
                  >
                    Approve
                  </button>
                ) : null}
              </div>
        </Box>
      </Modal>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => 99999 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default RequestSignModal;
